import React from 'react';
import Formsy from 'formsy-react';
import Modal from '../shared/Modal';
import Popup from 'reactjs-popup';
import FormRadio from '../form/Radio';
import FormsySimpleInput from '../form/FormsySimpleInput';
import RichTextEditor, { createValueFromString } from 'react-rte';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import {
  generateServiceDetailEmail,
  generateStaffServiceDetailEmail
} from '../../helpers/emailGenerators';
import { RTE_DEFAULT_TOOLBAR_CONFIG } from '../../const';
import withSplashMessage from '../splashMessage/withSplashMessage';
import { maskDate } from '../../masks';
import SVGWarningBang from '../../svg/WarningBang';
import SVGSuccessCheck from '../../svg/SuccessCheck';
import SVGClose from '../../svg/Close';
import Spinner from '../shared/Spinner';

class ServiceSendDetailsModal extends React.Component {
  state = {
    emailBody: createValueFromString('<p></p>', 'html'),
    audience: 'client',
    clientEmail: '',
    staffEmail: '',
    serviceID: null,
    showPopup: false,
    isSending: false
  };

  warningBang = (
    <span className="warning-bang">
      <SVGWarningBang />
    </span>
  );
  successCheck = (
    <span className="success-check">
      <SVGSuccessCheck />
    </span>
  );

  render() {
    const { emailBody, audience, isSending } = this.state;
    const { additional_dates } = this.props.service

    let saveBtnText = this.props.unsaved ? 'Save & Send' : 'Send';
    if (Array.isArray(additional_dates) && additional_dates.length > 0) {
      saveBtnText = 'Save & Send to All'
    }

    if (!this.props.isOpen) return '';
    return (
      <Modal isOpen={this.props.isOpen} onRequestClose={this.props.closeModal}>
        <div className="admin-wrapper">
          <Formsy onValidSubmit={this.onSubmit}>
            <h2 className="h2 cms__section-head">{this.getModalTitle()}</h2>

            {!this.props.staff && (
              <div className="form__row">
                <FormRadio
                  className="radio"
                  name="audience"
                  options={this.radioOptions()}
                  value={audience}
                  onChange={this.handleChange}
                  required
                />
              </div>
            )}

            {this.props.staff && (
              <div className="form__row">
                <p>Sending to: {this.props.staff.chef.email}</p>
              </div>
            )}

            <RichTextEditor
              value={emailBody}
              onChange={this.handleRTEChange}
              className="text-area text-area--edit"
              toolbarConfig={RTE_DEFAULT_TOOLBAR_CONFIG}
              autoFocus={true}
            />

            <div className="form__row">
              <div className="form__row-item--half">
                <div
                  className="btn btn--hollow-red-bright btn--full-width"
                  onClick={this.props.closeModal}
                >
                  Cancel
                </div>
              </div>
              <div className="form__row-item--half">
                <input
                  type="submit"
                  className="btn btn--solid-blue btn--full-width"
                  value={saveBtnText}
                  disabled={isSending}
                />
              </div>
            </div>
          </Formsy>
        </div>
        {this.renderPopup()}
        <Spinner isRequestOut={isSending}></Spinner>
      </Modal>
    );
  }

  radioOptions = () => {
    const {
      chef_email_recipients,
      chef_email_sent_at,
      client_email_recipients,
      client_email_sent_at
    } = this.state;

    const client =
      client_email_recipients && client_email_sent_at ? (
        <div>
          <p className="p p--pad-top">
            {this.successCheck} Client: {client_email_recipients}
            <span className="service-calendar-event-staff__p">
              Sent {maskDate(client_email_sent_at)}
            </span>
          </p>
        </div>
      ) : (
        <div>
          <p className="p p--pad-top">
            {this.warningBang} Client: N/A
            <span className="service-calendar-event-staff__p">
              Not Sent Yet
            </span>
          </p>
        </div>
      );

    const chef =
      chef_email_recipients && chef_email_sent_at ? (
        <div>
          <p className="p p--pad-top">
            {this.successCheck} Chef: {chef_email_recipients}
            <span className="service-calendar-event-staff__p">
              Sent {maskDate(chef_email_sent_at)}
            </span>
          </p>
        </div>
      ) : (
        <div>
          <p className="p p--pad-top">
            {this.warningBang} Chef: N/A
            <span className="service-calendar-event-staff__p">
              Not Sent Yet
            </span>
          </p>
        </div>
      );

    return [
      {
        label: 'Client',
        value: 'client',
        child: (
          <div>
            <FormsySimpleInput
              type="text"
              name="clientEmail"
              validations={{
                isEmailList: true,
                requiredIf: { audience: 'client' }
              }}
              value={this.state.clientEmail}
              onChange={this.handleChange}
            />
            <p className="small">
              Separate multiple email addresses with commas.
            </p>
            {client}
          </div>
        )
      },
      {
        label: 'Staff',
        value: 'staff',
        child: (
          <div>
            <FormsySimpleInput
              type="text"
              name="staffEmail"
              validations={{
                isEmailList: true,
                requiredIf: { audience: 'staff' }
              }}
              value={this.state.staffEmail}
              onChange={this.handleChange}
            />
            <p className="small">
              Separate multiple email addresses with commas.
            </p>
            {chef}
          </div>
        )
      }
    ];
  };

  handleRTEChange = emailBody => {
    this.setState({ emailBody });
  };

  handleChange = e => {
    const { name, value } = e.target;
    const email = generateServiceDetailEmail(value, this.props.service) || '';
    const emailBody =
      name === 'audience'
        ? createValueFromString(email, 'html')
        : this.state.emailBody;
    this.setState({ [name]: value, emailBody });
  };

  onSubmit = () => {
    const { grocery_list, audience } = this.state;
    if (audience === 'staff' && !grocery_list.approved ) {
      // Block send to chef if grocery list has not been approved.
      this.setState({ showPopup: true });
    } else {
      // Send service detail
      this.sendServiceDetail();
    }
  };

  sendServiceDetail = () => {
    if (this.props.staff) {
      const staffEmail = this.state.emailBody.toString('html');
      this.props.sendStaffMail(this.props.staff, staffEmail);
      return;
    }

    const { audience, clientEmail, staffEmail, emailBody } = this.state;
    const recipients = audience === 'staff' ? staffEmail : clientEmail;
    const recipient_type = audience === 'staff' ? 'chef' : 'client';

    const payload = {
      recipients: recipients.split(',').map(item => item.trim()),
      email_body: emailBody.toString('html'),
      recipient_type
    };

    // set loading state to true
    this.setState({ isSending: true });

    serviceAPI
      .sendService(this.state.serviceID, payload)
      .then(result => {
        this.props.addMessage({
          className: 'success',
          message: 'Email Sent Successfully'
        });
        this.props.closeModal();
        this.setState({ isSending: false });
      })
      .catch(err => {
        this.props.addMessage({
          className: 'error',
          message: `Error sending email: ${err}`
        });
        this.props.closeModal();
        this.setState({ isSending: false });
        console.log(err);
      });
  };

  closePopup = () => {
    this.setState({ showPopup: false });
  };

  renderPopup() {
    return (
      <Popup open={this.state.showPopup} onClose={this.closePopup} modal>
        {close => (
          <div className="popup">
            <span className="modal__close-btn" onClick={close}>
              <SVGClose />
            </span>

            <div className="content">
              <p className="p p--bold">Grocery list has not been approved.</p>
            </div>
            <div className="actions">
              <button
                className="btn btn--solid-blue"
                onClick={() => {
                  this.sendServiceDetail();
                }}
              >
                Send Anyway?
              </button>
            </div>
          </div>
        )}
      </Popup>
    );
  }

  getModalTitle() {
    return !this.props.staff
      ? 'Send Service Details To...'
      : 'Send Chef Email To...';
  }

  deriveState() {
    const {
      client = {},
      invited_chefs: staff = [],
      id,
      chef_email_recipients,
      chef_email_sent_at,
      client_email_recipients,
      client_email_sent_at,
      grocery_list
    } = this.props.service;
    const clientEmail = client && client.email ? client.email : '';
    const staffEmail =
      staff && staff.length
        ? staff
            .filter(chef => chef.status === 'accepted')
            .map(chef => chef.chef.email)
            .join(',')
        : '';

    let email =
      generateServiceDetailEmail(this.state.audience, this.props.service) || '';
    if (this.props.staff)
      email = generateStaffServiceDetailEmail(
        this.props.staff,
        this.props.service
      );

    const emailBody = createValueFromString(email, 'html');
    const audience = this.props.audience || 'client';

    return {
      clientEmail,
      staffEmail,
      emailBody,
      serviceID: id,
      chef_email_recipients,
      chef_email_sent_at,
      client_email_recipients,
      client_email_sent_at,
      audience,
      grocery_list
    };
  }

  componentDidMount() {
    // initialize state from props
    const state = this.deriveState();
    this.setState(state);
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (
      (this.props.isOpen && !prevProps.isOpen) || // it opened
      this.props.service !== prevProps.service // service changed
    ) {
      const state = this.deriveState();
      this.setState(state);
    }
  }
}

export default withSplashMessage(ServiceSendDetailsModal);



// WEBPACK FOOTER //
// ./src/components/service/ServiceSendDetailsModal.js